module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "slipbox__container"
  }, [_c('transition', {
    attrs: {
      "name": _vm.transitionNames
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visible),
      expression: "visible"
    }],
    class: _vm.clazz
  }, [_c('div', {
    directives: [{
      name: "clickout-side",
      rawName: "v-clickout-side",
      value: (_vm.onClickoutSide),
      expression: "onClickoutSide"
    }],
    class: [_vm.prefixCls + '__content'],
    style: (_vm.styls)
  }, [_c('div', {
    class: [_vm.prefixCls + '__header']
  }, [_vm._t("header", [_c('div', {
    class: _vm.headerInnerClazz
  }, [_c('t-icon', {
    class: _vm.headerArrowClazz,
    attrs: {
      "type": _vm.arrowType
    },
    nativeOn: {
      "click": function($event) {
        return _vm.onHideSlip($event)
      }
    }
  }), _vm._v(" "), _c('span', {
    class: [_vm.prefixCls + '__title']
  }, [_vm._v(_vm._s(_vm.title))])], 1)])], 2), _vm._v(" "), _c('div', {
    class: [_vm.prefixCls + '__body']
  }, [_vm._t("default")], 2)])])]), _vm._v(" "), (_vm.needBackDrop) ? _c('div', {
    staticClass: "slipbox__wrap--backdrop modal-backdrop",
    class: {
      'show': _vm.visible === true
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f60a72fc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/slipbox/slipbox.vue
// module id = 419
// module chunks = 0